import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
// import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Footer from './Footer';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import { AppBar, Toolbar, IconButton, ListItemSecondaryAction, Icon } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import DeleteIcon from '@material-ui/icons/Delete';
//import RenderTextFieldRedux from './RenderTextFieldRedux';
import ExpandMore from '@material-ui/icons/ExpandMore';
import BeneficiaryFilterExternalForm from './BeneficiaryFilterExternalForm';
import BeneficiaryFilterInternalForm from './BeneficiaryFilterInternalForm';
import { checkPermissionUser } from '../../functions/permissions-functions';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    //maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: 'inline',
  },
  inlinenew: {
    display: 'inline',
    color: '#0099A8'
  },
  styleaccordion : {
    borderLeft: '3px solid rgba(255, 198, 0)',
    // backgroundColor : "#5A5759",
    color : "black",
    minWidth : "100%",
    width: `100%`,
  },
  logo: {
    [theme.breakpoints.up('xs')]: {
        width: `30px`,
    },
    [theme.breakpoints.up('sm')]: {
        width: `50%`,
    },
    [theme.breakpoints.up('md')]: {
        width: `50%`,
    },
    [theme.breakpoints.up('lg')]: {
        width: `50%`,
    },
    [theme.breakpoints.up('xl')]: {
        width: `50%`,
    },
},
icon: {
    [theme.breakpoints.up('xs')]: {
        minWidth: '20%'
    },
    [theme.breakpoints.up('sm')]: {
        width: `20%`,
    },
    [theme.breakpoints.up('md')]: {
        width: `24%`,
    },
    [theme.breakpoints.up('lg')]: {
        width: `24%`,
    },
    [theme.breakpoints.up('xl')]: {
        width: `24%`,
    },
},
listItems: {
    [theme.breakpoints.up('xs')]: {
        color: 'white',
        fontSize: '70%'
    },
    [theme.breakpoints.up('sm')]: {
        color: 'white',
        fontSize: '100%'
    },
    [theme.breakpoints.up('md')]: {
        color: 'white',
        fontSize: '100%'
    },
    [theme.breakpoints.up('lg')]: {
        color: 'white',
        fontSize: '100%'
    },
    [theme.breakpoints.up('xl')]: {
        color: 'white',
        fontSize: '100%'
    },
},
Items: {
    [theme.breakpoints.up('xs')]: {
        color: 'white',
        width: '70%'
    },
    [theme.breakpoints.up('sm')]: {
        color: 'white',
        width: '100%'
    },
    [theme.breakpoints.up('md')]: {
        color: 'white',
        width: '100%'
    },
    [theme.breakpoints.up('lg')]: {
        color: 'white',
        width: '100%'
    },
    [theme.breakpoints.up('xl')]: {
        color: 'white',
        width: '100%'
    },
},
LogoImg: {
    [theme.breakpoints.up('xs')]: {
        width: '70%'
    },
    [theme.breakpoints.up('sm')]: {
        width: '100%'
    },
    [theme.breakpoints.up('md')]: {
        width: '100%'
    },
    [theme.breakpoints.up('lg')]: {
        width: '50%'
    },
    [theme.breakpoints.up('xl')]: {
        width: '50%'
    },
},
logoaccordion : {
    textAlign : "rigth"
},
imgLogo: {height: '40%'},
styledialog : {maxWidth : "100%", maxHeight : "80%", width : "100%", height : "80vh"}
}));

const BeneficiaryList = ({  onCloseDialogBeneficiaryList, openDialogBeneficiaryList, handleSubmitBeneficiariesInternal, handleSubmitBeneficiariesExternal, beneficiariesInternalFilter, beneficiariesExternalFilter,
    getBeneficiarySelected, openDialogBeneficiaryForm, editBeneficiary, deleteBeneficiary, handleConvertMask, handleChangeInputFilterBeneficiariesInternal, handleChangeInputFilterBeneficiariesExternal, userPermissions}) => {
  const classes = useStyles();
  /* const handleOk = () => {
    
  }; */

  const sendBeneficiarySelected = (data) => {
    getBeneficiarySelected(data)
  }

  const sendEditBeneficiarySelecter = (data) => {
    editBeneficiary(data)
  }

  /* const renderTitleTabs = (urlicon, title) => {
    return <List>
                <ListItem key={1} className = {classes.Items}>
                    <ListItemAvatar>
                        <Avatar src = {urlicon} variant="square"  className={classes.imgLogo} />
                    </ListItemAvatar>
                    <ListItemText primary={ <Typography className = {classes.listItems}> { title }</Typography> }  />
                </ListItem>
            </List>
} */

  return (
            <Dialog
                fullScreen
                open={ openDialogBeneficiaryList }
                onClose={ onCloseDialogBeneficiaryList }
                maxWidth= 'xs'
                disableBackdropClick
                disableEscapeKeyDown
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description" 
            >
            <DialogTitle id="simple-dialog-title"> {'Seleccionar Beneficiario ' }</DialogTitle>
            <AppBar >
            <Toolbar style = {{ position: 'relative'}}>
                <IconButton edge="start" color="inherit" onClick={onCloseDialogBeneficiaryList} aria-label="close">
                    <CloseIcon />
                </IconButton>
                <Typography variant="h6" style = {{ flex: 1}}>
                    {'Seleccionar Beneficiario ' }
                </Typography>
            </Toolbar>
            </AppBar>
            <br />
            {checkPermissionUser(userPermissions, 1) &&
            <Accordion >
                <AccordionSummary
                    // expandIcon={<Avatar src = {process.env.PUBLIC_URL + '/icons/39.png'} variant="square"  className={classes.imgLogo} />}
                    expandIcon={<ExpandMore style={{ color: "rgba(255, 198, 0)" }} className={classes.imgLogo} />}
                    
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    className = {classes.styleaccordion}
                >
                    <List>
                        <ListItem key={1} >
                            {/* <ListItemAvatar>
                                <Avatar src = {process.env.PUBLIC_URL + '/images/32.png'} variant="square" className={classes.imgLogo}/>
                            </ListItemAvatar> */}
                            <ListItemText primary={ <Typography> BENEFICIARIOS INTERNOS </Typography> }  />
                        </ListItem>
                    </List>
                
                </AccordionSummary>
                <AccordionDetails>
                    {renderBeneficiaryListInternal(beneficiariesInternalFilter, classes, sendBeneficiarySelected, openDialogBeneficiaryForm, sendEditBeneficiarySelecter, deleteBeneficiary, "INTERNO", handleConvertMask, handleChangeInputFilterBeneficiariesInternal, handleSubmitBeneficiariesInternal)}
                </AccordionDetails>
            </Accordion>}
            <br />
            {checkPermissionUser(userPermissions, 2) &&
            <Accordion>
                <AccordionSummary
                    // expandIcon={<Avatar src = {process.env.PUBLIC_URL + '/icons/39.png'} variant="square"  className={classes.imgLogo} />}
                    expandIcon={<ExpandMore style={{ color: "rgba(255, 198, 0)" }} className={classes.imgLogo} />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    className = {classes.styleaccordion}
                >
                    <List>
                        <ListItem key={1} >
                            {/* <ListItemAvatar>
                                <Avatar src = {process.env.PUBLIC_URL + '/images/33.png'} variant="square" className={classes.imgLogo}/>
                            </ListItemAvatar> */}
                            <ListItemText primary={ <Typography> BENEFICIARIOS OTRAS INSTITUCIONES </Typography> }  />
                        </ListItem>
                    </List>
                
                </AccordionSummary>
                <AccordionDetails>
                    {renderBeneficiaryListExternal(beneficiariesExternalFilter, classes, sendBeneficiarySelected, openDialogBeneficiaryForm, sendEditBeneficiarySelecter, deleteBeneficiary, "OTRAS INSTITUCIONES", handleConvertMask, handleChangeInputFilterBeneficiariesExternal, handleSubmitBeneficiariesExternal)}
                </AccordionDetails>
            </Accordion>}
                
                {/* <SimpleTabs id = {'BENEFICIARY'} handleClose = { onCloseDialogBeneficiaryList } tabHeaders={[{ title : renderTitleTabs(process.env.PUBLIC_URL+"/images/32.png", "Beneficiarios interno"), key : '1' },{ title : renderTitleTabs(process.env.PUBLIC_URL+"/images/33.png", "Beneficiarios de otras instituciones"), key : '2', color: '#382c2c' }]} tabContent={ [
                    {
                        //mandamos list para que se renderize en el componente
                        id: 'interno',
                        content: renderBeneficiaryList(beneficiaries.filter( b => {
                            return b.beneficiary === 'INTERNO'
                        }), classes, sendBeneficiarySelected, openDialogBeneficiaryForm, sendEditBeneficiarySelecter, deleteBeneficiary)
                    },
                    {
                        //mandamos list para que se renderize en el componente
                        id: 'externo',
                        content: renderBeneficiaryList(beneficiaries.filter( b => {
                            return b.beneficiary === 'EXTERNO'
                        }), classes, sendBeneficiarySelected, openDialogBeneficiaryForm, sendEditBeneficiarySelecter, deleteBeneficiary)
                    }
                    
                ] } /> */}
                {/* <List className={classes.root}>
                    <ListItem alignItems="flex-start" >
                        <ListItemAvatar>
                            <Avatar alt="Remy Sharp" src={`${urlIcons}user.png`} />
                        </ListItemAvatar>
                        <ListItemText
                            primary={"Agregar Nuevo Beneficiario"}
                        />
                        <ListItemSecondaryAction>
                                            
                            <IconButton edge="end" aria-label="delete" onClick = {() => openDialogBeneficiaryForm() } >
                                <Icon>add</Icon>
                            </IconButton>
                            
                        </ListItemSecondaryAction>
                    </ListItem>
                </List> */}
                {/* <Button onClick={() => openDialogBeneficiaryForm() } variant="outlined" color="primary">Agregar Beneficiario</Button> */}
                <br/>
                <Footer />
        </Dialog>
    
  );
}

const renderBeneficiaryListExternal = (beneficiaries, classes, sendBeneficiarySelected, openDialogBeneficiaryForm, sendEditBeneficiarySelecter, deleteBeneficiary, typebeneficiary, handleConvertMask, handleChangeInputFilterBeneficiariesExternal, handleSubmitBeneficiariesExternal) => {
    if (beneficiaries.length > 0 ) {
        return <List className={classes.root}>
                <ListItem alignItems="flex-start">
                    <ListItemText 
                        primary = {
                            <BeneficiaryFilterExternalForm
                                handleSubmit = { handleSubmitBeneficiariesExternal }
                                handleChangeFilter = { handleChangeInputFilterBeneficiariesExternal }
                            />
                        }
                    />
                </ListItem>
                {
                    beneficiaries.map( row => {
                        return  <div key = {row.id}>
                                    <ListItem button alignItems="flex-start" onClick = { () => sendBeneficiarySelected(row)}>
                                        {/* <ListItemAvatar>
                                            <Avatar alt="Remy Sharp" src={process.env.PUBLIC_URL + '/icons/comun.png'} />
                                        </ListItemAvatar> */}
                                        <ListItemText
                                        primary = { row.name }
                                        secondary={
                                            <React.Fragment>
                                            <Typography
                                                component="span"
                                                variant="body2"
                                                className={classes.inline}
                                                color="textPrimary"
                                            >
                                                { row.type_name + " - " +row.name_institution}
                                            </Typography>
                                            { ` — ${(row.type_name === "TARJETA DE CREDITO") ? handleConvertMask(row.number) : row.number}` }
                                            </React.Fragment>
                                        }
                                        />
                                        <ListItemSecondaryAction>
                                            
                                            <IconButton edge="end" aria-label="delete" onClick = {() => deleteBeneficiary(row) } >
                                                <DeleteIcon />
                                            </IconButton> 
                                            <IconButton edge="end" aria-label="delete" onClick = {() => sendEditBeneficiarySelecter(row) } >
                                                <Icon>create</Icon>
                                            </IconButton>
                                            
                                            
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <Divider variant="inset" component="li" />
                                </div>
                    })
                }

                <ListItem alignItems="flex-start" button onClick = { () => openDialogBeneficiaryForm()}>
                    {/* <ListItemAvatar>
                        <Avatar alt="Remy Sharp" src={process.env.PUBLIC_URL + '/icons/36.png'} /> 
                    </ListItemAvatar> */}
                    <ListItemText
                        primary = { <Typography
                                        component="span"
                                        variant="body2"
                                        className={classes.inlinenew}
                                        color="textPrimary"
                                    >
                                        { "AGREGAR NUEVO BENEFICIARIO "+typebeneficiary }
                                    </Typography> }
                    
                    />
                    
                </ListItem>
            </List>
    } else {
        return <List className={classes.root}>
                
                    <ListItem button alignItems="flex-start" >
                        <ListItemText
                            primary = { '(No existen Beneficiarios)' }
                        />
                    </ListItem>
                    <ListItem alignItems="flex-start" button onClick = { () => openDialogBeneficiaryForm()}>
                        {/* <ListItemAvatar>
                            <Avatar alt="Remy Sharp" src={process.env.PUBLIC_URL + '/icons/36.png'} />  
                        </ListItemAvatar> */}
                        <ListItemText
                            primary = { <Typography
                                            component="span"
                                            variant="body2"
                                            className={classes.inlinenew}
                                            color="textPrimary"
                                        >
                                            { "AGREGAR NUEVO BENEFICIARIO "+typebeneficiary }
                                        </Typography> }
                        
                        />
                    
                    </ListItem>
                    
                
            </List>
    }
            
}

const renderBeneficiaryListInternal = (beneficiaries, classes, sendBeneficiarySelected, openDialogBeneficiaryForm, sendEditBeneficiarySelecter, deleteBeneficiary, typebeneficiary, handleConvertMask, handleChangeInputFilterBeneficiariesInternal, handleSubmitBeneficiariesInternal) => {
    if (beneficiaries.length > 0 ) {
        return <List className={classes.root}>
                <ListItem alignItems="flex-start">
                    <ListItemText 
                        primary = {
                            <BeneficiaryFilterInternalForm
                                handleSubmit = { handleSubmitBeneficiariesInternal }
                                handleChangeFilter = { handleChangeInputFilterBeneficiariesInternal }
                            />
                        }
                    />
                </ListItem>
                {
                    beneficiaries.map( row => {
                        return  <div key = {row.id}>
                                    <ListItem button alignItems="flex-start" onClick = { () => sendBeneficiarySelected(row)}>
                                        {/* <ListItemAvatar>
                                            <Avatar alt="Remy Sharp" src={process.env.PUBLIC_URL + '/icons/comun.png'} />
                                        </ListItemAvatar> */}
                                        <ListItemText
                                        primary = { row.name }
                                        secondary={
                                            <React.Fragment>
                                            <Typography
                                                component="span"
                                                variant="body2"
                                                className={classes.inline}
                                                color="textPrimary"
                                            >
                                                { row.type_name + " - " +row.name_institution}
                                            </Typography>
                                            { ` — ${(row.type_name === "TARJETA DE CREDITO") ? handleConvertMask(row.number) : row.number}` }
                                            </React.Fragment>
                                        }
                                        />
                                        <ListItemSecondaryAction>
                                            
                                            <IconButton edge="end" aria-label="delete" onClick = {() => deleteBeneficiary(row) } >
                                                <DeleteIcon />
                                            </IconButton> 
                                            <IconButton edge="end" aria-label="delete" onClick = {() => sendEditBeneficiarySelecter(row) } >
                                                <Icon>create</Icon>
                                            </IconButton>
                                            
                                            
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <Divider variant="inset" component="li" />
                                </div>
                    })
                }

                <ListItem alignItems="flex-start" button onClick = { () => openDialogBeneficiaryForm()}>
                    {/* <ListItemAvatar>
                        <Avatar alt="Remy Sharp" src={process.env.PUBLIC_URL + '/icons/36.png'} /> 
                    </ListItemAvatar> */}
                    <ListItemText
                        primary = { <Typography
                                        component="span"
                                        variant="body2"
                                        className={classes.inlinenew}
                                        color="textPrimary"
                                    >
                                        { "AGREGAR NUEVO BENEFICIARIO "+typebeneficiary }
                                    </Typography> }
                    
                    />
                    
                </ListItem>
            </List>
    } else {
        return <List className={classes.root}>
                
                    <ListItem button alignItems="flex-start" >
                        <ListItemText
                            primary = { '(No existen Beneficiarios)' }
                        />
                    </ListItem>
                    <ListItem alignItems="flex-start" button onClick = { () => openDialogBeneficiaryForm()}>
                        {/* <ListItemAvatar>
                            <Avatar alt="Remy Sharp" src={process.env.PUBLIC_URL + '/icons/36.png'} />  
                        </ListItemAvatar> */}
                        <ListItemText
                            primary = { <Typography
                                            component="span"
                                            variant="body2"
                                            className={classes.inlinenew}
                                            color="textPrimary"
                                        >
                                            { "AGREGAR NUEVO BENEFICIARIO "+typebeneficiary }
                                        </Typography> }
                        
                        />
                    
                    </ListItem>
                    
                
            </List>
    }
            
}
export default  BeneficiaryList